export default "__VITE_ASSET__ubqVrQGV__"